'use client';

import { useEffect, useRef } from 'react';

/**
 * Returns a boolean stating whether the component is currently mounted.
 */
export function useIsMounted() {
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    return { isMounted: isMounted.current };
}
